import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as R from 'ramda';

import SmartQuestion from 'js/execution/v2/panels/smart_questions_panel/shared_proptypes/smart_question';

import Form from './form';

const SmartQuestionsForm = ({currentResult, questions, user, answers, handleAnswerGiven}) => (
    <div id="questions-content" className="row">
        <Form
            currentResult={currentResult}
            questions={questions}
            answers={answers}
            profile={user.profile}
            handleAnswerGiven={handleAnswerGiven}
        />
    </div>
);

SmartQuestionsForm.propTypes = {
    questions: PropTypes.arrayOf(SmartQuestion).isRequired,
    currentResult: PropTypes.bool,
    user: PropTypes.shape({email: PropTypes.string}),
    answers: PropTypes.object,
    handleAnswerGiven: PropTypes.func.isRequired
};

export default connect(
    R.pick(['user']),
    R.always({})
)(SmartQuestionsForm);



// WEBPACK FOOTER //
// ./components/smart_question/index.js